﻿import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { KbObject } from "@models/configurators/kb-object";
import { UiObject } from "@models/configurators/ui-object";
import { IManufactureObject, PartOperationDetail } from "..";

@Kbo(CToken.PartOperation)
export class PartOperation extends KbObject implements IManufactureObject {

    public $properties: UiObject[];
    public opDesc: string;
    public opCode: string;
    public _metadata: any = {}
;

    public static getMetadataProperties() {
        return [];
    }

    private _operationDetails: PartOperationDetail[];
    @Enumerable()
    public get operationDetails(): PartOperationDetail[] {
        if (!this._operationDetails) this._operationDetails = [];
        return this._operationDetails;
    }
    public set operationDetails(val) {
        this._operationDetails = val;
    }

    constructor(kom: KbObjectManager, data?: any) {
        super(kom);
        this._metadata = {};

        for (const key in data) {
            const value = data[key];
            if (!Array.isArray(value)) (this as any)[key] = value;
        }
    }

    public getIdentifyingProperty() {
        return "opDesc";
    }
}